/**
 * Os identificadores de tela, num lugar só.
 *
 * POR QUE TEXTO E NÃO ÍNDICE: a navegação era `0..5`, e um Sinal que leva o
 * usuário até o bloco que explica o número dele recebe de `telaDoIndicador()`
 * a chave da TELA, não uma posição de menu. Com id textual o link é direto;
 * com índice seria preciso uma segunda tabela de tradução — exatamente o tipo
 * de duplicata que já produziu neste produto quatro indicadores com dois nomes.
 */

import { TELAS } from '../diagnostico/catalogo';

export const ABAS = {
  // As sete telas do redesign. O id é o MESMO de `TELAS`, de propósito.
  DADOS: TELAS.DADOS,
  SAUDE: TELAS.SAUDE,
  RESULTADO: TELAS.RESULTADO,
  CAIXA_CICLO: TELAS.CAIXA_CICLO,
  DIVIDA_RETORNO: TELAS.DIVIDA_RETORNO,
  PAINEL: TELAS.PAINEL,
  ANALISE: TELAS.ANALISE,

  // Telas que continuam existindo ao lado das sete: o fluxo mensal, os
  // demonstrativos para conferir conta a conta com o contador, e a
  // configuração do administrador.
  FECHAR_MES: 'fechar-mes',
  DRE: 'dre',
  BALANCO: 'balanco',
  // Planos NÃO exige dado carregado: ela é a resposta a "por que este mês não
  // entrou?" e a "por que o parecer não saiu?", e as duas perguntas podem
  // acontecer antes de existir dashboard.
  PLANOS: 'planos',
  CONFIG: 'config'
};

export default ABAS;
